import { type MousePosT } from '../stage-provider';
const delta = 5;
export const STAGE_HOTKEYS = {
  ArrowDown: {
    deltaX: 0,
    deltaY: -delta
  },
  ArrowUp: {
    deltaX: 0,
    deltaY: delta
  },
  ArrowRight: {
    deltaX: -delta,
    deltaY: 0
  },
  ArrowLeft: {
    deltaX: delta,
    deltaY: 0
  }
};
export const EVENT_TYPE = Object.freeze({
  POINTER_UP: 'pointerup',
  POINTER_DOWN: 'pointerdown',
  POINTER_MOVE: 'pointermove',
  POINTER_DRAG: 'drag',
  POINTER_DRAG_START: 'dragstart',
  POINTER_DRAG_END: 'dragend',
  POINTER_ENTER: 'pointerenter',
  POINTER_LEAVE: 'pointerleave',
  POINTER_DOUBLE_CLICK: 'doubleclick',
  POINTER_RIGHT_CLICK: 'contextmenu'
});
export type EventTypeT = (typeof EVENT_TYPE)[keyof typeof EVENT_TYPE];
export const DRAG_STATE = Object.freeze({
  DRAG_START: 'DRAG_START',
  DRAG: 'DRAG',
  DRAG_END: 'DRAG_END'
});
type DragStateT = (typeof DRAG_STATE)[keyof typeof DRAG_STATE];
export type DragEventT = {
  dragState: DragStateT;
  dragStartMousePos: MousePosT;
  target: EventTarget | null;
};
export const DEFAULT_FRAME_RATE = 24;
export const TRACKING_ERROR_MESSAGES = {
  TRACKING_FAILED: (range: {
    start: number;
    end: number;
  }) => `Failed fetching tracking results for the given range: ${range.start + 1} - ${range.end + 1}`
};